// extracted by mini-css-extract-plugin
export default {"musicIcon":"MusicToggle_musicIcon__CJXj7"};